// test1143
(1143 && 0);
